/*
  Store a list of thumbor transforms
  Note: This is not where the transforms are set, just a reference to them for use in JS.
*/

const THUMBOR_TRANSFORMS = {
  lg_3x2_fi: {
    width: 1200,
    height: 800,
    type: 'fit',
  },
  md_3x2_crop: {
    width: 720,
    height: 480,
    type: 'crop',
  },
  md_3x2_ffi: {
    width: 720,
    height: 480,
    type: 'fullFit',
  },
};

/*
  Calculate the dimensions of an image transformed by thumbor based on the
  original dimesions of the image and the appropriate transform type.
*/

export const calculateAspectRatioFit = (
  srcWidth,
  srcHeight,
  transformName,
  transforms = THUMBOR_TRANSFORMS
) => {
  // Return original dimensions for unsupported transform type
  if (!transforms[transformName]) {
    return { width: srcWidth, height: srcHeight };
  }

  const transformWidth = transforms[transformName].width;
  const transformHeight = transforms[transformName].height;
  const transformType = transforms[transformName].type;

  const widthExceeded = srcWidth > transformWidth;
  const heightExceeded = srcHeight > transformHeight;

  // Assumes up scale
  if (transformType === 'fullFit') {
    const ratio = Math.max(
      transformWidth / srcWidth,
      transformHeight / srcHeight
    );
    return { width: srcWidth * ratio, height: srcHeight * ratio };
  }

  // Assumes no up scale
  if (transformType === 'fit') {
    if (widthExceeded || heightExceeded) {
      const ratio = Math.min(
        transformWidth / srcWidth,
        transformHeight / srcHeight
      );
      return { width: srcWidth * ratio, height: srcHeight * ratio };
    }
    return { width: srcWidth, height: srcHeight };
  }

  // Assumes up scale
  if (transformType === 'crop') {
    return { width: transformWidth, height: transformHeight };
  }
};
